/* ============================================================
   Oasis Nutrition — global scroll-reveal
   One IntersectionObserver for every `.oasis-fade-in` element,
   replacing the copy-pasted per-section observers.

   Safety model (paired with oasis-tokens.css):
   - The hidden state only exists under `html.oasis-anim`, which
     this script adds. No JS -> content renders visible.
   - Respects prefers-reduced-motion (content stays visible).
   - Re-scans on Shopify theme editor section loads so merchants
     never see stuck-invisible sections while customizing.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    // Leave everything visible; also satisfy any legacy CSS that
    // hides .oasis-fade-in unconditionally (older custom blocks).
    document.querySelectorAll('.oasis-fade-in').forEach(function (el) {
      el.classList.add('oasis-visible');
    });
    return;
  }

  document.documentElement.classList.add('oasis-anim');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('oasis-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  function scan(root) {
    (root || document).querySelectorAll('.oasis-fade-in:not(.oasis-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  scan();

  // Theme editor: newly (re)rendered sections need re-observing.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
